export default {
  USER_INFO: 'USER_INFO',
  GRAPH_INFO: 'GRAPH_INFO',
  GRAPH_INFO_Client: 'GRAPH_INFO_Client',
  NODES: 'NODES',
  SINGLE_NODE: 'SINGLE_NODE',
  MAKER_LIST: 'MAKER_LIST',
  CIRCLE_LIST: 'CIRCLE_LIST',
  POLYLINE_LIST: 'POLYLINE_LIST',
  POLYGON_LIST: 'POLYGON_LIST',
  RECTANGLE_LIST: 'RECTANGLE_LIST'
}


// WEBPACK FOOTER //
// ./src/store/mutation-types.js